module.exports = __webpack_public_path__ + "img/defense-2001-master.80e4cb2f.jpg";